
document.addEventListener("DOMContentLoaded", () => {
  new window.Vue({
    name: 'searchBar',
    el: '#search-component',
    data: function () {
      return {
        query: '',
        showSearch: false,
        searchResults: [],
        pages: [],
        noResults: false,
      }
    },

    methods: {
      closeSearch: function () {
        this.showSearch = false;
        document.querySelector('body').classList.remove('in-search')
        this.pages = [];
        this.searchResults = [];
        this.noResults = false;
        window.history.pushState({}, document.title, window.location.pathname);
      },
      openSearchBar: function () {
        this.showSearch = true;
        document.querySelector('body').classList.toggle('in-search')
      },
      afterEnter: function () {
        this.$refs.query.focus();
      },
      doSearch: function () {
       window.location = `/search?q=${this.query}`
      },
    }
  })
});